const roles = ["planning_manager", "project_manager", "super_admin"];
export default roles;
